import React, { useState } from 'react';
import { Plus, ListMusic, X } from 'lucide-react';
import { Button } from '../ui/button';
import { toast } from 'sonner';
import QueueManager from '../QueueManager';

const QueuePanel = ({
  queue,
  queueTotalDuration,
  queueSearchQuery,
  onQueueSearchChange,
  onReorderQueue,
  onRemoveFromQueue,
  onLoadToDeck,
  onClearQueue,
  onOpenUpload,
  onFileSelect,
  formatDuration
}) => {
  const filteredQueue = queueSearchQuery
    ? queue.filter(t => 
        t.title?.toLowerCase().includes(queueSearchQuery.toLowerCase()) ||
        t.artist?.toLowerCase().includes(queueSearchQuery.toLowerCase())
      )
    : queue;

  const handleClearQueue = () => {
    if (window.confirm('Vider la file d\'attente ?')) {
      onClearQueue();
      toast.success('File d\'attente vidée');
    }
  };

  return (
    <div className="flex-1 flex flex-col gap-2 min-h-0">
      {/* Upload Button */}
      <div className="bg-dark-card/80 backdrop-blur-xl border border-sunset-orange/30 rounded-lg p-2 flex-shrink-0">
        <Button
          onClick={onOpenUpload}
          size="sm"
          className="w-full bg-gradient-to-r from-sunset-orange to-sunset-secondary hover:from-purple-700 hover:to-blue-700 text-xs"
        >
          <Plus className="w-4 h-4 mr-1" />
          Ajouter des titres
        </Button>
        <input
          id="file-upload-input"
          type="file"
          multiple
          accept="audio/*"
          onChange={onFileSelect}
          className="hidden"
        />
      </div>

      {/* Queue with Drag & Drop */}
      <div className="flex-1 bg-dark-card/80 backdrop-blur-xl border border-sunset-orange/30 rounded-lg p-3 flex flex-col min-h-0">
        <div className="flex items-center justify-between gap-2 mb-2 flex-shrink-0">
          <div className="flex items-center gap-2">
            <ListMusic className="w-4 h-4 text-purple-400" />
            <h2 className="text-sm font-semibold text-text-primary">File d'attente</h2>
          </div>
          <div className="flex items-center gap-1">
            <span className="px-1.5 py-0.5 rounded-full text-xs bg-purple-500/20 text-sunset-orange">
              {queue.length}
            </span>
            <span className="text-xs text-sunset-orange/60">•</span>
            <span className="px-1.5 py-0.5 rounded-full text-xs bg-purple-500/10 text-sunset-orange font-mono">
              {formatDuration(queueTotalDuration)}
            </span>
            {queue.length > 0 && (
              <Button
                onClick={handleClearQueue}
                size="sm"
                variant="ghost"
                className="h-6 w-6 p-0 text-red-400 hover:text-red-300 hover:bg-red-500/10"
                title="Vider la file"
              >
                <X className="w-3 h-3" />
              </Button>
            )}
          </div>
        </div>
        
        {/* Search bar */}
        {queue.length > 0 && (
          <div className="mb-2 flex-shrink-0">
            <input
              type="text"
              placeholder="Rechercher dans la file..."
              value={queueSearchQuery}
              onChange={(e) => onQueueSearchChange(e.target.value)}
              className="w-full px-3 py-1.5 text-sm bg-dark-input/50 border border-sunset-orange/20 rounded-lg text-white placeholder-purple-300/40 focus:outline-none focus:border-sunset-orange/50"
            />
          </div>
        )}
        
        <div className="flex-1 overflow-y-auto min-h-0" style={{scrollbarWidth: 'thin', scrollbarColor: 'rgb(147 51 234) rgb(30 41 59)'}}>
          <QueueManager
            queue={filteredQueue}
            onReorder={onReorderQueue}
            onRemoveTrack={onRemoveFromQueue}
            onLoadToDeck={onLoadToDeck}
          />
          
          {queueSearchQuery && filteredQueue.length === 0 && (
            <div className="text-center text-sunset-orange/50 text-sm py-4">
              Aucun résultat pour "{queueSearchQuery}"
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default QueuePanel;